<template>
    <AppModal :title="$t('labels.print_document')" ref="modal" @on-hide="hide">
        <div class="modal-body">
            <FormGroup :label="$t('labels.document')">
                <AppSelect
                    v-model="documentType"
                    :selected-value="documentType.value"
                    :options="documentTypes"
                    option-key="key"
                    option-value="value"
                />
            </FormGroup>
        </div>
        <div class="modal-footer justify-content-end">
            <AppButton color="indigo" :disabled="loading" @click="printDocument">
                <i class="icon-printer mr-2"></i>
                {{ $t('buttons.print') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";

import { httpClient } from "../../../../../services/HttpClient.ts";
import { PDFDocument } from 'pdf-lib';

export default {
    name: 'PrintDocumentModal',
    components: {
        AppModal, FormGroup, AppButton, AppSelect
    },
    data() {
        return {
            loading: false,
            documentType: { key: 'sticker_file', value: this.$t('labels.sticker_file'), extraField: 'delivery.stickerFile' },
            documentTypes: [
                { key: 'sticker_file', value: this.$t('labels.sticker_file'), extraField: 'delivery.stickerFile' },
                { key: 'waybill_file', value: this.$t('labels.delivery_invoice'), extraField: 'delivery.waybillFile' },
            ],
            selectedOrderUuids: [],
            sortOrders: [],
        }
    },
    methods: {
        show(selectedOrderUuids, sortOrders = []) {
            this.selectedOrderUuids = selectedOrderUuids;
            this.sortOrders = sortOrders;
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
            this.selectedOrderUuids = [];
            this.sortOrders = [];
            this.documentType = { key: 'sticker_file', value: this.$t('labels.sticker_file'), extraField: 'delivery.stickerFile' };
        },
        async printDocument() {
            this.loading = true;

            try {
                const response = await httpClient.get(
                    `/projects/${this.$route.params.projectUuid}/crm/orders`,
                    {
                        uuids: this.selectedOrderUuids,
                        extra_fields: [this.documentType.extraField],
                        orders: this.sortOrders,
                    }
                );

                const orders = response.data.data;
                const fileKey = this.documentType.key;
                const fileUrls = orders
                    .map(order => order.delivery?.[fileKey]?.url)
                    .filter(Boolean);

                if (!fileUrls.length) {
                    return;
                }

                const mergedPdf = await PDFDocument.create();

                for (const url of fileUrls) {
                    const response = await httpClient.post('/proxy/http-request', { method: 'GET', url }, false, { responseType: 'blob' });
                    const pdfBytes = await response.data.arrayBuffer();
                    const pdf = await PDFDocument.load(pdfBytes);
                    const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                    pages.forEach(page => mergedPdf.addPage(page));
                }

                const mergedBytes = await mergedPdf.save();
                const blob = new Blob([mergedBytes], { type: 'application/pdf' });
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                this.hide();
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
